import React from 'react'
import {DayPickerRangeController, DateRangePicker} from 'react-dates';
import moment from 'moment'
import cn from 'classnames'
import css from './style.scss'
import './datepicker.css'
class DatePicker extends React.Component{
  constructor(props){
    super(props)
    this.state={
      startDate:props.startDate,
      endDate:props.endDate,
      focusedInput:props.inline ? "startDate" : undefined,
      blockBefore: props.blockBefore
    }
  }
  handleDateChange=({ startDate, endDate })=>{
    this.setState({ startDate, endDate})
    if(endDate){
      if(this.props.onDatesChange){this.props.onDatesChange({startDate,endDate})};
    }
  }
  onFocusChange=(focusedInput)=>{
    this.setState({
     focusedInput: !focusedInput ? (this.props.inline ? "startDate" : undefined) : focusedInput
    });
  }
  isOutsideRange=(day)=>{
    let now=moment().endOf("day")
    if(this.props.blockBefore){
      return (day < this.props.blockBefore) | day > now
    }
    return day > now
  }
  render(){
    let startMonth=document.body.clientWidth<800 ? 0 : 0;
    let numberOfMonths=document.body.clientWidth<800 ? 1 : 1;
    let portal=document.body.clientWidth<800;
    if(this.props.inline){
      return (
        <div className={cn(css.datepicker, this.props.className)}>
          <DayPickerRangeController
            orientation="horizontal"
            withPortal={false}
            isOutsideRange={this.isOutsideRange}
            numberOfMonths={numberOfMonths}
            hideKeyboardShortcutsPanel
            initialVisibleMonth={() => moment().subtract(startMonth, 'month')}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onDatesChange={this.handleDateChange}
            focusedInput={this.state.focusedInput}
            onFocusChange={this.onFocusChange}
          />
        </div>
      )
    }else{
      return (
        <div className={cn(css.datepickerButton, this.props.className)}>
          <DateRangePicker
            orientation="horizontal"
            withPortal={portal}
            numberOfMonths={numberOfMonths}
            hideKeyboardShortcutsPanel
            isOutsideRange={this.isOutsideRange}
            initialVisibleMonth={() => moment().subtract(startMonth, 'month')}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onDatesChange={this.handleDateChange}
            focusedInput={this.state.focusedInput}
            onFocusChange={this.onFocusChange}
          />
        </div>
      )
    }

  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/shared/datePicker/index.js